import React from "react";

const GoogleSheetsIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.5408 0L34.5408 10L29.5408 10.9091L24.5408 10L23.6317 5L24.5408 0Z",
  fill: "#188038"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.5409 10V0H8.17722C6.67041 0 5.44995 1.22045 5.44995 2.72727V37.2727C5.44995 38.7795 6.67041 40 8.17722 40H31.8136C33.3204 40 34.5409 38.7795 34.5409 37.2727V10H24.5409Z",
  fill: "#34A853"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.9045 15.4545V28.6363H29.0864V15.4545H10.9045ZM18.8591 26.3636H13.1773V23.1818H18.8591V26.3636ZM18.8591 20.9091H13.1773V17.7273H18.8591V20.9091ZM26.8136 26.3636H21.1318V23.1818H26.8136V26.3636ZM26.8136 20.9091H21.1318V17.7273H26.8136V20.9091Z",
  fill: "white"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(GoogleSheetsIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;